import React from 'react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-white" data-id="element-107">
      <div className="max-w-3xl mx-auto text-center" data-id="element-108">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-12" data-id="element-109">
          🏆 Oferta Especial de Lanzamiento
        </h2>

        <div className="bg-white rounded-[2rem] border-2 border-brand-red p-8 md:p-12 shadow-xl relative max-w-xl mx-auto" data-id="element-110">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-red text-white px-6 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase" data-id="element-111">
            CONTENIDO DEL PACK:
          </div>

          <div className="space-y-4 mb-8 text-left" data-id="element-112">
            <div className="flex justify-between items-center border-b border-brand-creamDark pb-4" data-id="element-113">
              <span className="text-brand-text font-medium" data-id="element-114">
                12 Tomos digitales completos
              </span>
              <span className="text-brand-gray font-medium" data-id="element-115">$97</span>
            </div>
            <div className="flex justify-between items-center border-b border-brand-creamDark pb-4" data-id="element-116">
              <span className="text-brand-text font-medium" data-id="element-117">
                5 Bonos exclusivos
              </span>
              <span className="text-brand-gray font-medium" data-id="element-118">$85</span>
            </div>
            <div className="flex justify-between items-center pt-2" data-id="element-119">
              <span className="font-bold text-brand-text" data-id="element-120">VALOR TOTAL:</span>
              <span className="font-bold text-brand-gray line-through" data-id="element-121">
                $182
              </span>
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-122">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-123">
              <span className="text-6xl md:text-7xl font-black text-brand-red tracking-tight" data-id="element-124">
                $19 USD
              </span>
            </div>
            <span className="text-brand-gray font-medium text-lg" data-id="element-125">
              Pago único
            </span>
          </div>

          <CTAButton href="https://musica-lista.impultienda.ar/checkout" className="w-full mb-6 text-lg py-5" data-id="element-126">
            QUIERO EL PACK MÚSICA LISTA
          </CTAButton>

          <p className="text-xs text-brand-gray font-medium" data-id="element-127">
            Descarga inmediata &middot; Pago único &middot; Acceso de por vida
            &middot; 7 días de garantía
          </p>
        </div>
      </div>
    </section>;
}